import { Fragment } from "react";
import { useWatch } from "react-hook-form";
import Grid from "@mui/material/Grid";
import CommonFields from "components/CommonFields";
import generateTestId from "utils/generateTestId";
import fixture from "./fixture";

const RentalIncome = ({ prefix, activeFields, pane }: { prefix: string; activeFields: string[]; pane?: string }) => {
    const rentalIncome = useWatch({ name: `${prefix}.rentalIncome` });
    return (
        <Grid container direction="row" justifyContent="flex-start" alignItems="center">
            {fixture.map(({ name, inputType, reactHookFormRegisterOptions, editable, options, extendedOptions, subtitle, label }, index) => {
                if (name === "propertyType") {
                    if (rentalIncome.propertyDetail === "Commercial") {
                        options = extendedOptions!.isCommercial.options;
                    } else if (rentalIncome.propertyDetail === "Residential") {
                        options = extendedOptions!.isResidential.options;
                    } else if (rentalIncome.propertyDetail === "Industrial") {
                        options = extendedOptions!.isIndustrial.options;
                    } else {
                        options = extendedOptions!.isAgricultural.options;
                    }
                }
                activeFields.push(name);
                return (
                    <Fragment key={index}>
                        <CommonFields
                            inputType={inputType}
                            name={`${prefix}.rentalIncome.${name}`}
                            data-testid={generateTestId(`${label}-rental-${pane}`, "field")}
                            options={
                                options?.map((option) => ({
                                    value: option.value,
                                    label: option.label,
                                })) || []
                            }
                            label={label}
                            reactHookFormRegisterOptions={reactHookFormRegisterOptions}
                            readOnly={localStorage.getItem("disable_form") === "true" || !editable}
                            subtitle={subtitle}
                        />
                    </Fragment>
                );
            })}
        </Grid>
    );
};

export default RentalIncome;
